import axios from 'axios';
import axiosRetry from 'axios-retry';
// import { bytesToSize, getSignedUrl } from './dropzoneHelper';
import { getSignedUrl, bytesToSize, remainigPercentFormat, secondsToTime } from './dropzoneHelper';
import { cleanPath, sendErrorReport } from './MediaUploaderNewHelper';
const _ = require('lodash');

axiosRetry(axios, { retries: 5 });
// axiosRetry(axios, { retryDelay: axiosRetry.exponentialDelay });

export class PromiseQueue {
  constructor(
    promises = [],
    concurrentTasks = 5,
    stateUpdateFn,
    transferRateFn,
    setUploadStarted,
    setTotalFilesRemaining,
    setTotalSizeRemaining,
    SFMediaSubmissionID,
    markUploadComplete,
    setTotalFailed,
    setUploadInProgress,
    setTotalPending,
    setTotalUploaded,
    sortBy,
    acceptedFileState
  ) {
    this.concurrent = concurrentTasks;
    this.total = promises.length;
    this.todo = promises;
    this.running = [];
    this.complete = [];
    this.failed = [];
    this.updateProgress = stateUpdateFn;
    this.transferRate = transferRateFn;
    this.setUploadStarted = setUploadStarted;
    this.setTotalFilesRemaining = setTotalFilesRemaining;
    this.totalFileSize = promises.reduce((accum, next) => {
      return next.file.size + accum;
    }, 0);
    this.setTotalSizeRemaining = setTotalSizeRemaining;
    this.SFMediaSubmissionID = SFMediaSubmissionID;
    this.markUploadComplete = markUploadComplete;
    this.setTotalFailed = setTotalFailed;
    this.setUploadInProgress = setUploadInProgress;
    this.setTotalPending = setTotalPending;
    this.setTotalUploaded = setTotalUploaded;
    this.sortBy = sortBy;
    this.acceptedFileState = acceptedFileState;

    // console.log('this.totalfilesize: ', bytesToSize(this.totalFileSize));
  }

  async retry() {
    this.setUploadInProgress(true);

    let failed = this.failed.slice();
    console.log('failed', failed);
    this.failed = [];
    this.todo = failed;
    this.run();
  }

  get runAnother() {
    // console.log(this.running.length < this.concurrent && this.todo.length);
    return this.running.length < this.concurrent && this.todo.length;
  }

  // toGraph() {
  //   let { todo, running, complete } = this;
  //   logUpdate(`

  //       todo: [${todo.map(toX)}]
  //       running: [${running.map(toX)}]
  //       complete: [${complete.map(toX)}]

  //   `);
  // }

  async uploadFileViaAxiosPromise(task) {
    let that = this;
    let start = Date.now();

    return getSignedUrl(this.SFMediaSubmissionID, task.path, task.file.type, 'WRITE')
      .then((signedUrl) => {
        if (!signedUrl) {
          throw Error({ message: 'Error getting signed URL', obj: task });
        }
        return axios
          .put(`${signedUrl}`, task.file, {
            headers: {
              'Content-Type': task.file.type,
            },
            onUploadProgress: function (progressEvent) {
              // console.log('progressEvent: ', progressEvent);
              // let kb = progressEvent.loaded / 1000;
              // let sec = (Date.now() - start) / 1000;
              // let kbps = Math.floor(kb / sec);
              // if (Math.random() <= 0.3) {
              //   that.transferRate(kbps);
              //   that.updateProgress((prevState) => {
              //     // console.log('[I] setState in uploadFile 2', prevState);
              //     //if file name matches then set uploaded to true for that file
              //     let currentFileProgress = Math.ceil((progressEvent.loaded * 100) / progressEvent.total);
              //     return prevState.map((ps) =>
              //       ps.name === file.name ? { ...ps, uploaded: 'inprogress', progress: currentFileProgress } : ps
              //     );
              //   });
              // }
            },
          })
          .catch((putError) => {
            // console.log('[E] putError toJSON', putError.toJSON());
            if (putError.response) {
              console.log(
                '[E] putError putError.response',
                putError.response,
                putError.response.data,
                putError.response.status,
                putError.response.headers
              );
            } else if (putError.request) {
              console.log('[E] putError putError.request', putError.request);
            } else {
              console.log('[E] putError putError.message', putError.message);
            }
            throw putError;
          });
      })
      .catch((err) => {
        // console.log('[E] getSignedUrl toJSON', err.toJSON());
        if (err.response) {
          console.log(
            '[E] getSignedUrl err.response',
            err.response,
            err.response.data,
            err.response.status,
            err.response.headers
          );
        } else if (err.request) {
          console.log('[E] getSignedUrl getSignedUrl.request', err.request);
        } else {
          console.log('[E] getSignedUrl getSignedUrl.message', err.message);
        }
        throw err;
        // sendErrorReport(err);
        // that.updateProgress((prevState) => {
        //   // console.log('[I] setState in uploadFile 2', prevState);
        //   //if file name matches then set uploaded to true for that file
        //   return prevState.map((ps) => (ps.path === task.path ? { ...ps, uploaded: 'error', retries: 5 } : ps));
        // });
      });
  }

  async run() {
    while (this.runAnother) {
      let task = this.todo.shift();
      this.uploadFileViaAxiosPromise(task)
        .then((d) => {
          // console.log('done upload promise.then', d.config.data.path, d);
          if (d && d.status === 200) {
            // console.log('<<<Match?>>>>>>', d.config.data.path, task.path);
            let filename = task.path; // d.config.data.path;
            // this.setTotalFilesRemaining((prevState) => {
            //   // console.log('setTotalFilesRemaining: ', prevState);
            //   return --prevState;
            // });

            //   this.setTotalSizeRemaining((prevState) => {
            //     // console.log('setTotalSizeRemaining: ', prevState);
            //     return this.totalFileSize - d.config.data.size;
            //   });

            this.updateProgress((prevState) => {
              // console.log('[I] setState in uploadFile 2', prevState);
              //if file name matches then set uploaded to true for that file
              return prevState.map((ps) => (ps.path === filename ? { ...ps, uploaded: 'uploaded' } : ps));
            });

            // this.setTotalPending(this.todo.length + this.running.length);
            this.setTotalUploaded((prevUploaded) => prevUploaded + 1);
            this.complete.push(this.running.shift());
          } else {
            throw Error('no 200 status');
          }

          //queue next task

          // this.run();
        })
        .catch((err) => {
          console.log('[E] uploadFileViaAxiosPromise toJSON', err);

          console.log('[E] Task in error: ', task, this.running);
          this.running = this.running.filter((r) => r.path !== task.path);
          console.log('[I] updated running after reducing failed', this.running);

          this.failed.push(task);

          this.updateProgress((prevState) => {
            // console.log('[I] setState in uploadFile 2', prevState);
            //if file name matches then set uploaded to true for that file
            return prevState.map((ps) => (ps.path === task.path ? { ...ps, uploaded: 'error' } : ps));

            // return _.sortBy(arr, 'uploaded');
          });

          sendErrorReport(err);

          //requeue and run

          // let failedTask = this.running.shift();
          // failedTask.retry++;
          // if (failedTask.retry < 3) {
          //   console.log('task queing for retry.', failedTask);
          //   this.todo.push(failedTask);
          //   this.updateProgress((prevState) => {
          //     // console.log('[I] setState in uploadFile 2', prevState);
          //     //if file name matches then set uploaded to true for that file
          //     return prevState.map((ps) =>
          //       ps.path === task.path ? { ...ps, uploaded: 'error', retries: failedTask.retry } : ps
          //     );
          //   });

          //   this.run();
          // } else {
          //   console.log('retry limit exceed. marking it as completely failed', failedTask);
          //   this.failed.push(failedTask);
          //   this.updateProgress((prevState) => {
          //     // console.log('[I] setState in uploadFile 2', prevState);
          //     //if file name matches then set uploaded to true for that file
          //     return prevState.map((ps) =>
          //       ps.path === task.path ? { ...ps, uploaded: 'failed', retries: failedTask.retry } : ps
          //     );
          //   });
          // }

          // this.setTotalPending(this.todo.length + this.running.length);
          // this.setTotalFailed(this.failed.length);
          // this.setTotalUploaded(this.complete.length);
        })
        .finally(() => {
          if (this.todo.length === 0 && this.running.length === 0) {
            let allCompletedFiles = this.complete.map((c) => c.file);
            // this.markUploadComplete(allCompletedFiles);
            // this.setUploadStarted(false);
            this.setUploadInProgress(false);
          }

          // this.setTotalFailed(
          //   this.acceptedFileState.filter((f) => f.uploaded === 'error' || f.uploaded === 'failed').length
          // );
          this.setTotalFailed(this.failed.length);
          this.setTotalPending(this.todo.length + this.running.length);
          console.log('complete: ', this.complete);
          console.log('failed: ', this.failed);
          console.log('pending=todo,running: ', this.todo.length, this.running.length, this.todo, this.running);
          this.run();
        });

      this.running.push(task);

      //   this.toGraph();
    }
  }
}
